import { render, staticRenderFns } from "./ChildVehicles.vue?vue&type=template&id=b8ba6b22&"
import script from "./ChildVehicles.vue?vue&type=script&lang=js&"
export * from "./ChildVehicles.vue?vue&type=script&lang=js&"
import style0 from "./ChildVehicles.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports